import { Card } from '@bpinternal/ui-kit-next'
import cx from 'classnames'

export type CardGrid<T> = {
  items: T[]
  children?: React.ReactNode | ((item: T) => React.ReactNode)
} & Omit<React.ComponentProps<typeof Card>, 'children'>

export const CardGrid = <T,>({ items, children, ...props }: CardGrid<T>) => {
  return (
    <div {...props} className={cx('mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3', props.className)}>
      {items.map((item) => (typeof children === 'function' ? children(item) : children))}
    </div>
  )
}
